import { WelmProvider } from '@welm';
import { Config } from 'config/config';
import { SystemContextProvider } from 'Context/SystemContextProvider';
import { createRoot } from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
const url = Config().getApiUrl();

root.render(
  <WelmProvider apiUrl={url}>
    <SystemContextProvider>
      <App />
    </SystemContextProvider>
  </WelmProvider>
);
